import { render, staticRenderFns } from "./SirketProfil.vue?vue&type=template&id=5f62ee9c&"
import script from "./SirketProfil.vue?vue&type=script&lang=js&"
export * from "./SirketProfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports